import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const DASHBOARD_TYPOGRAPHY = {
  sectionTitle: "text-xs font-semibold uppercase tracking-[0.18em] text-white/65",
  value: "text-2xl font-semibold tracking-tight text-white",
  meta: "text-sm text-white/72",
};

const IndicatorsTab = ({ indicators, rsiColor, rsiState, trend, trendColor }) => (
  <div className="h-full overflow-auto">
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <Card className="bg-white/5 border-white/10">
        <CardHeader className="pb-2">
          <CardTitle className={DASHBOARD_TYPOGRAPHY.sectionTitle}>RSI</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={DASHBOARD_TYPOGRAPHY.value}>{indicators.rsi?.toFixed(1) || "N/A"}</div>
          <div className={`text-sm font-medium ${rsiColor}`}>{rsiState}</div>
        </CardContent>
      </Card>

      <Card className="bg-white/5 border-white/10">
        <CardHeader className="pb-2">
          <CardTitle className={DASHBOARD_TYPOGRAPHY.sectionTitle}>Trend</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={`text-2xl font-semibold tracking-tight ${trendColor}`}>{trend}</div>
          <div className={DASHBOARD_TYPOGRAPHY.meta}>Supertrend</div>
        </CardContent>
      </Card>

      <Card className="bg-white/5 border-white/10">
        <CardHeader className="pb-2">
          <CardTitle className={DASHBOARD_TYPOGRAPHY.sectionTitle}>MACD</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={DASHBOARD_TYPOGRAPHY.value}>{indicators.macd?.toFixed(2) || "N/A"}</div>
          <div className={DASHBOARD_TYPOGRAPHY.meta}>Signal: {indicators.macd_signal?.toFixed(2) || "N/A"}</div>
        </CardContent>
      </Card>

      <Card className="bg-white/5 border-white/10">
        <CardHeader className="pb-2">
          <CardTitle className={DASHBOARD_TYPOGRAPHY.sectionTitle}>EMA Cross</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={DASHBOARD_TYPOGRAPHY.value}>{indicators.ema_9?.toFixed(2) || "N/A"}</div>
          <div className={DASHBOARD_TYPOGRAPHY.meta}>EMA 21: {indicators.ema_21?.toFixed(2) || "N/A"}</div>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default React.memo(IndicatorsTab);
